'use client';

import { useState } from 'react';
import type { WorkPageData } from '@/lib/skin-zero/record-data';
import { SzMedia } from './skin-zero-ui';

export function SkinZeroWorkMedia({ data }: { data: WorkPageData }) {
  const [mode, setMode] = useState<'still' | 'film' | 'interactive'>(data.videoUrl ? 'film' : 'still');
  return (
    <div className="space-y-3">
      <div
        data-artwork-frame="intrinsic"
        className="overflow-hidden rounded-[10px] border border-neutral-200 bg-neutral-100 dark:border-neutral-800 dark:bg-neutral-900"
      >
        {mode === 'film' && data.videoUrl ? (
          <video
            src={data.videoUrl}
            poster={data.imageUrl ?? undefined}
            controls
            playsInline
            preload="metadata"
            className="block h-auto w-full object-contain"
            aria-label={data.title}
          />
        ) : mode === 'interactive' && data.htmlUrl ? (
          <iframe
            src={data.htmlUrl}
            sandbox="allow-scripts"
            title={data.title}
            className="w-full border-0"
            style={{ aspectRatio: data.mediaAspect || undefined, minHeight: data.mediaAspect ? undefined : '65vh' }}
          />
        ) : (
          <SzMedia url={data.imageUrl} alt={data.title} layout="intrinsic" eager />
        )}
      </div>
      {(data.videoUrl || data.htmlUrl) && (
        <div className="flex flex-wrap gap-2" role="group" aria-label="Artwork media">
          {[
            ...(data.imageUrl ? [['still', 'Still']] : []),
            ...(data.videoUrl ? [['film', 'Film']] : []),
            ...(data.htmlUrl ? [['interactive', 'Interactive work']] : []),
          ].map(([value, label]) => (
            <button
              key={value}
              type="button"
              aria-pressed={mode === value}
              onClick={() => setMode(value as typeof mode)}
              className={`rounded-full border px-3 py-1.5 text-sm ${mode === value ? 'border-neutral-950 bg-neutral-950 text-white dark:border-neutral-50 dark:bg-neutral-50 dark:text-neutral-950' : 'border-neutral-300 dark:border-neutral-700'}`}
            >
              {label}
            </button>
          ))}
        </div>
      )}
      {data.htmlUrl && (
        <a
          href={data.htmlUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-sm text-neutral-500 underline"
        >
          Open interactive work in a new tab ↗
        </a>
      )}
    </div>
  );
}
